import { render, staticRenderFns } from "./ReviewYourAnswersGA.vue?vue&type=template&id=0df14706"
import script from "./ReviewYourAnswersGA.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersGA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports